import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const PasswordValidationWidget = ({ password }) => {
  const requirements = [
    {
      label: 'Min 8 Characters',
      isValid: password.length >= 8
    },
    {
      label: '1 Uppercase Letter',
      isValid: /[A-Z]/.test(password)
    },
    {
      label: '1 Lowercase Letter',
      isValid: /[a-z]/.test(password)
    },
    {
      label: '1 Number',
      isValid: /\d/.test(password)
    },
    {
      label: '1 Special Character',
      isValid: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
      {requirements.map((req, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          {req.isValid ? (
            <CheckCircleIcon fontSize="small" sx={{ color: 'green', mr: 1 }} />
          ) : (
            <CancelIcon fontSize="small" sx={{ color: 'red', mr: 1 }} />
          )}
          <Typography
            variant="body2"
            sx={{ color: req.isValid ? 'green' : 'red' }}
          >
            {req.label.toUpperCase()}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PasswordValidationWidget;
